module.exports = __webpack_public_path__ + "static/media/link.71532c47.svg";